import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Composants structurels
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnnouncementPopup from './components/AnnouncementPopup';

// Pages / Contenu
import HomeContent from './components/HomeContent';
import UserProfile from './pages/UserProfile';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

// Styles
import './App.css';

// Composant Wrapper interne pour accéder au hook useLocation
const AppContent = () => {
  const [isMusicPlaying, setIsMusicPlaying] = useState(false);
  const audioRef = useRef(null);
  const [hasEnteredMusicOverlay, setHasEnteredMusicOverlay] = useState(false);
  const [isMusicOverlayFadingOut, setIsMusicOverlayFadingOut] = useState(false);

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Effet pour scroller en haut lors du changement de route
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleMusic = () => {
    if (audioRef.current) {
      if (isMusicPlaying) {
        audioRef.current.pause();
        setIsMusicPlaying(false);
      } else {
        audioRef.current.play()
          .then(() => {
            setIsMusicPlaying(true);
          })
          .catch(error => {
            console.error("Erreur lors de la lecture de la musique :", error);
            setIsMusicPlaying(false);
          });
      }
    }
  };

  const handleEnterMusicOverlay = (withMusic) => {
    setIsMusicOverlayFadingOut(true);
    setTimeout(() => {
      setHasEnteredMusicOverlay(true);
      if (withMusic) {
        if (!isMusicPlaying && audioRef.current) {
          audioRef.current.play()
            .then(() => setIsMusicPlaying(true))
            .catch(error => {
              console.error("Erreur lors de la lecture de la musique :", error);
              setIsMusicPlaying(false);
            });
        } else if (isMusicPlaying && !audioRef.current?.playing) {
          audioRef.current?.play().then(() => setIsMusicPlaying(true)).catch(e => console.error(e));
        }
      } else {
        if (audioRef.current) {
          audioRef.current.pause();
        }
        setIsMusicPlaying(false);
      }
    }, 600);
  };

  return (
    <div className="App">
      <audio ref={audioRef} loop>
        <source src="/audio/ambiance1.mp3" type="audio/mpeg" />
        Votre navigateur ne supporte pas l'élément audio.
      </audio>

      {/* Toast d'accueil musical - Seulement sur la home */}
      {location.pathname === '/' && !hasEnteredMusicOverlay && (
        <div className={`music-toast ${isMusicOverlayFadingOut ? 'fade-out' : ''}`}>
          <button className="close-toast" onClick={() => handleEnterMusicOverlay(false)}>×</button>
          <div className="toast-content">
            <h3>Bienvenue ✨</h3>
            <p className="toast-subtitle">Chez Studio Ambre !</p>
            <p>Une petite ambiance musicale pour accompagner votre visite ? 🎶</p>
            <div className="toast-buttons">
              <button className="btn-yes" onClick={() => handleEnterMusicOverlay(true)}>💖 Oui, avec musique</button>
              <button className="btn-no" onClick={() => handleEnterMusicOverlay(false)}>🛋️ Non merci</button>
            </div>
            <small className="toast-hint">
              (Vous pourrez activer/désactiver la musique depuis l’icône en haut)
            </small>
            <small className="toast-credits">
              site propulsé par <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>infocolab</a>
            </small>
          </div>
        </div>
      )}

      {/* Navbar présente partout sauf sur l'admin */}
      {!isAdminRoute && (
        <Navbar isMusicPlaying={isMusicPlaying} toggleMusic={toggleMusic} />
      )}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<HomeContent />} />

        <Route
          path="/profil"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <UserProfile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Footer présent partout sauf sur l'admin */}
      {!isAdminRoute && <Footer />}

      {/* Notification globale gérée par AnnouncementPopup */}
      <AnnouncementPopup />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;